import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './switch.module.scss';

export const Switch = (props: SwitchProps) => {
  const { label, checked, onChange, danger, className, alignment = 'default', ...rest } = props;

  const reverse = alignment === 'reverse';

  return (
    <label
      className={clsx(styles.switchHolder, className, {
        [styles.reverse]: reverse,
      })}
    >
      {typeof label === 'string' ? <span className="text-ellipsis">{label}</span> : label}
      <div
        tabIndex={0}
        className={clsx(styles.switchBase, {
          [styles.danger]: danger,
          [styles.checked]: checked,
        })}
        onKeyDown={(e) => ['Enter', ' '].includes(e.key) && onChange(!checked)}
      >
        <small />
        <input
          tabIndex={-1}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          aria-label={typeof label === 'string' ? label : undefined}
          role="switch"
          {...rest}
        />
      </div>
    </label>
  );
};

interface SwitchProps {
  danger?: boolean;
  checked: boolean;
  readOnly?: boolean;
  className?: string;
  label?: string | ReactNode;
  alignment?: 'default' | 'reverse';
  onChange: (checked: boolean) => void;
}
